<template>
  <div class="bg-white p-3"><policies></policies></div>
</template>

<script>
import policies from "./policies";
export default {
  components: { policies },
};
</script>
